<div class="widgets-grid" cdkDropList cdkDropListOrientation="mixed" [cdkDropListDisabled]="!enableDragAndDrop()" (cdkDropListDropped)="drop($event)">
  @for (widget of widgets(); track widget) {
    <div
      class="widget-item"
      [class.widget-item--sm]="widget.options.size === WidgetSize.small"
      [class.widget-item--md]="widget.options.size === WidgetSize.medium"
      [class.widget-item--lg]="widget.options.size === WidgetSize.large"
      [class.widget-item--draggable]="enableDragAndDrop()"
      cdkDrag
      [cdkDragDisabled]="!enableDragAndDrop()"
    >
      <div class="widget-content">
        <iot-platform-ui-widget-item (dispatchEvent)="dispatchEvent.emit($event)" [widget]="widget" />
      </div>
    </div>
  }
</div>
